export interface AuctionBidDetails {
  Id: number;
  AdminId: number;
  CategoryId: number;
  StartDate: Date;
  EndDate: Date;
  Status: AuctionBidStatus;
  ImageUrl: string;
  BidCount: number;
  ItemName: string;
  ItemDescription: string;
  LastBid: number;
  ItemWon: boolean;
  FinalBidDateTime: Date;
  RedeemDateTime: Date;
  /** 0 = not redeemed, 1 = redeemed */
  RedeemStatus: number;
  Barcode: string;
}

export enum AuctionBidStatus {
  All = 0,
  Active = 1,
  Completed = 2,
  Failed = 3,
  Inactive = 4
}
